import ClearIcon from "@mui/icons-material/Clear";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  Box,
  Button,
  Card,
  IconButton,
  Modal,
  Stack,
  Typography
} from "@mui/material";

import LinearProgress from "@mui/material/LinearProgress";
import PropTypes from "prop-types";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bulkUploadApi } from "../../store/question-bank/bulkUpload";
import { qnsBankListApi } from "../../store/question-bank/list";

export default function BulkQsnBank({ open, setOpen, id }) {
  const bulkQnsBnk = useSelector((state) => state?.bulkUpload,
  );
  const { loading } = bulkQnsBnk;
  const [selectedFile, setSelectedFile] = useState(null);

  const ref = useRef(null);
  const dispatch = useDispatch();

  const handleClose = () => {
    setOpen(false);
    setSelectedFile(null);
  };

  const uploadConfirm = async () => {
    console.log("data", selectedFile);
    let formData = new FormData();
    formData.append("file", selectedFile);
    await dispatch(bulkUploadApi(formData));

    if (!bulkQnsBnk?.loading) {
      dispatch(qnsBankListApi());
      setOpen(false);
      setSelectedFile(null);
    }
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <Card className="modal" sx={{ width: "30%" }}>
          <Stack alignItems="flex-end">
            <IconButton onClick={handleClose}>
              <HighlightOffIcon />
            </IconButton>
          </Stack>
          <Stack alignItems="center" my={2}>
            <Typography variant="h5" fontWeight={600}>
              Please Select a file to upload ?
            </Typography>
          </Stack>
          <Stack alignItems="center" my={2}>
            {selectedFile ? (
              <Typography variant="h5" fontWeight={600}>
                {selectedFile.name}
                <IconButton onClick={() => setSelectedFile(null)}>
                  <ClearIcon />
                </IconButton>
              </Typography>
            ) : (
              <>
                <input
                  accept=".csv,.xlxs,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  style={{ display: "none" }}
                  id="raised-button-file"
                  multiple
                  type="file"
                  ref={ref}
                  onChange={(e) => setSelectedFile(e.target?.files[0])}
                />
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => ref.current.click()}
                >
                  Upload File
                </Button>
              </>
            )}
            {loading ? (
              <Box sx={{ width: "60%" }}>
                <LinearProgress />
              </Box>
            ) : null}
          </Stack>

          <Stack sx={{ mt: 2 }} justifyContent="center" direction="row">
            <Button
              variant="outlined"
              onClick={() => handleClose()}
              sx={{ mr: 2 }}
            >
              Back
            </Button>
            <Stack direction="row" spacing={1}>
              <Button
                variant="contained"
                onClick={() => uploadConfirm()}
                disabled={!selectedFile ? true : false}
              >
                Confirm
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Modal>
    </>
  );
}

BulkQsnBank.propTypes = {
  open: PropTypes.any,
  setOpen: PropTypes.any,
  id: PropTypes.any,
};
